import { render, staticRenderFns } from "./HorizontalNav.vue?vue&type=template&id=4f6a2c9a&scoped=true&"
import script from "./HorizontalNav.vue?vue&type=script&lang=js&"
export * from "./HorizontalNav.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNav.vue?vue&type=style&index=0&id=4f6a2c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a2c9a",
  null
  
)

export default component.exports